import DocumentPage from '../../shared/DocumentPage';
import CvCertificationItem from './CvCertificationItem';
import CvHeader from './CvHeader';
import CvMainContent from './CvMainContent';
import CvSection from './CvSection';
import CvSidebar from './CvSidebar';

export default function ICCCvTwoPages({ data, composition, options }) {
  const firstExperiences = composition.experiences.slice(0, 2);
  const remainingExperiences = composition.experiences.slice(2);
  const firstEducation = composition.education.slice(0, 1);
  const remainingEducation = composition.education.slice(1);
  const firstTrainings = composition.trainings.slice(0, 1);
  const remainingTrainings = composition.trainings.slice(1);
  const extraCertifications = composition.certifications.slice(3);
  return <>
    <DocumentPage pageNumber={1} totalPages={2} documentType="CV" variant="cv" metadata={data.metadata}>
      <CvHeader employee={data.employee} presentation={data.presentation} />
      <div className="cv-layout"><CvSidebar data={data} composition={composition} options={options} /><CvMainContent data={data} skills={composition.coreSkills} experiences={firstExperiences} education={firstEducation} trainings={firstTrainings} /></div>
    </DocumentPage>
    <DocumentPage pageNumber={2} totalPages={2} documentType="CV" variant="cv cv-continuation" metadata={data.metadata}>
      <CvHeader employee={data.employee} compact />
      <CvMainContent data={data} showSummary={false} showSkills={false} experiences={remainingExperiences} references={composition.references} education={remainingEducation} trainings={remainingTrainings} />
      {extraCertifications.length > 0 && <CvSection title="Habilitations et certifications"><div className="cv-certification-grid">{extraCertifications.map((item) => <CvCertificationItem key={item.id || item.name} certification={item} />)}</div></CvSection>}
    </DocumentPage>
  </>;
}
